import { z } from '../zod.js';

// These mirror the TypeScript enums on the API's Ticket model
// (apps/api/src/scanner/TicketModel.ts). Values must stay identical — a
// drift test in apps/api asserts it.
export const TICKET_STATUS = Object.freeze({
  PAID: 'PAID',
  CANCELED: 'CANCELED',
} as const);

export const TicketStatusValidationEnum = z.enum(TICKET_STATUS);

export const TICKET_CHECK_IN_STATUS = Object.freeze({
  UNCHECKEDIN: 'UNCHECKEDIN',
  CHECKEDIN: 'CHECKEDIN',
} as const);

export const TicketCheckInStatusValidationEnum = z.enum(TICKET_CHECK_IN_STATUS);

export const TICKET_CHECK_IN_METHOD = Object.freeze({
  QRSCAN: 'QRSCAN',
  MANUAL: 'MANUAL',
} as const);

export const TicketCheckInMethodValidationEnum = z.enum(TICKET_CHECK_IN_METHOD);

export const TICKET_PRICING = Object.freeze({
  paid: 'paid',
  pwyw: 'pwyw',
  free: 'free',
} as const);

export const TicketPricingValidationEnum = z.enum(TICKET_PRICING);
